<div
  dropdown
  [isDisabled]="sections.isEmpty() || disabled"
  class="dropdown qa-toc-dropdown"
  keyboard-nav="true"
>
  <button
    dropdownToggle
    [disabled]="sections.isEmpty() || disabled"
    class="btn btn-default columns dropdown-toggle shrink qa-toc-dropdown-trigger"
    data-bs-toggle="dropdown"
    type="button"
  >
    <ng-container i18n="@@tableOfContents-btn-tableOfContents"
      >Table of Contents</ng-container
    >
  </button>

  <ul *dropdownMenu class="dropdown-menu u-scrollable-menu">
    <li *ngFor="let sectionIdentifier of sections">
      <rl-toc-submenu
        [currentDepth]="0"
        [maxDepth]="3"
        [sectionIdentifier]="sectionIdentifier"
        [containerStructure]="containerStructure"
        [sectionsById]="sectionsById"
      >
      </rl-toc-submenu>
    </li>
  </ul>
</div>
